"use client";

import Icon from "@/components/icons/Icons";
import { useIsMobile } from "@/utils/useIsMobile";
import { motion } from "framer-motion";
import Image from "next/image";
import { useEffect, useState } from "react";

export default function RiskScannerAnimation() {
  const [showTag, setShowTag] = useState<boolean>(false);
  const isMob = useIsMobile(768)

  useEffect(() => {
    setTimeout(() => {
      setShowTag(true);
    }, 3000);
  }, []);

  return (
    <>
      <Image
        src="/next_assets/images/portfolio-services/animated-cards-step-3.png"
        width={264}
        height={340}
        alt="card"
        className="object-cover relative z-0"
      />

      <motion.div
        className="absolute z-1 left-0 top-0 w-full h-0.5 shadow-[0_2px_10px_rgba(245,158,11,0.5)] bg-[#FE9A00]"
        initial={{ y: 6 }}
        animate={{
          y: isMob ? [3, 224, 3]:[6, 328, 6],
        }}
        transition={{
          duration: 3,
          ease: "easeInOut",
          repeat: Infinity,
        }}
      />

      {showTag && (
        <motion.span
          initial={{ opacity: 0, x: 40 }}
          animate={{ opacity: 1, x: 20 }}
          transition={{ duration: 0.5 }}
          className="absolute z-1 right-0 top-[10%] bg-white border border-[#FFE2E2] rounded-full shadow-[0px_9.44px_11.8px_-7.08px_#0000001A,0px_23.6px_29.5px_-5.9px_#0000001A] px-3 py-1.5 sm:py-2 text-[11px] font-semibold text-[#364153] flex items-center gap-2"
        >
          <span className="rounded-full p-1 bg-red-50">
            <Icon.errorWarningIcon className="w-3.5 h-3.5 text-red-500" />
          </span>
          Risk Found
        </motion.span>
      )}
    </>
  );
}
